// extracted by mini-css-extract-plugin
export default {"status-badge":"eOFrwb8H","disabled":"uQdz7cD9","good":"WuNRR8G5","really_bad":"I4g2pk2v","bad":"A3MNFsQB","neutral":"uBURsIKj"};